import * as React from "react";
import { connect } from "react-redux";
export class Loader extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (this.props.mapLoading ? React.createElement("div", { className: "sk-circle" },
            React.createElement("div", { className: "sk-circle1 sk-child" }),
            React.createElement("div", { className: "sk-circle2 sk-child" }),
            React.createElement("div", { className: "sk-circle3 sk-child" }),
            React.createElement("div", { className: "sk-circle4 sk-child" }),
            React.createElement("div", { className: "sk-circle5 sk-child" }),
            React.createElement("div", { className: "sk-circle6 sk-child" }),
            React.createElement("div", { className: "sk-circle7 sk-child" }),
            React.createElement("div", { className: "sk-circle8 sk-child" }),
            React.createElement("div", { className: "sk-circle9 sk-child" }),
            React.createElement("div", { className: "sk-circle10 sk-child" }),
            React.createElement("div", { className: "sk-circle11 sk-child" }),
            React.createElement("div", { className: "sk-circle12 sk-child" })) : null);
    }
}
;
export const mapStateToProps = ({ shoppingList, authenticated, signInModal, favoriteStores, mapLoading }, ownProps) => {
    return {
        mapLoading
    };
};
export default connect(mapStateToProps)(Loader);
//# sourceMappingURL=map-loader.js.map